import { Component, Input, OnInit } from '@angular/core';
import { Employee } from '@app/models/employee/employee.model';
import { Survey } from '@app/models/performance/survey.model';
import { AuthService, NotifyService } from '@app/services';
import { BaseForm } from '@forms/base.form';
import { FetchEmployees } from './fetch-employees-for-survey-summary.service';

@Component({
    selector: 'app-form-survey-summary',
    templateUrl: './survey-summary.template.html',
    providers: [FetchEmployees],
})
export class SurveySummaryForm extends BaseForm implements OnInit {
    @Input() survey: Survey;
    @Input() participants: Map<number, boolean>;

    employees: Employee[] = [];
    selectedEmployees: Employee[] = [];
    templates = [];

    constructor(
        private auth: AuthService,
        private readonly notify: NotifyService,
        private readonly fetchEmployees: FetchEmployees
    ) {
        super();
    }

    async ngOnInit(): Promise<void> {
        try {
            const [employees] = await this.fetchEmployees.forCompanyId(this.auth.company.id);
            this.employees = employees;
        } catch (e) {
            this.notify.error(e);
        }
    }

    onParticipantsChanged(): void {
        this.selectedEmployees = this.employees.filter((employee) => this.participants.get(employee.id));
    }

    onTemplatesLoaded(templates): void {
        this.templates = templates;
    }

    getSelectedTemplateName(): string {
        return this.templates?.find((template) => template.id == this.survey.templateId)?.name ?? '';
    }
}
